import { FC } from "react";
import { Image } from "@/components/Image/Image";
import { Author } from "@/lib/contentful/contentModel/author";
import { getImageUrl } from "@/lib/contentful/util";

interface Props {
  author: Author;
}

export const PostAuthor: FC<Props> = ({ author }) => {
  return (
    <div className="flex items-center">
      <Image
        className="h-[40px] w-[40px] rounded-full object-cover"
        src={getImageUrl(author.fields.avatar)}
        alt={author.fields.name}
        width={40}
        height={40}
      ></Image>
      <div className="ml-[20px] text-[16px] font-medium text-black">
        {author.fields.name}{" "}
        <span className="ml-[8px] text-[16px] font-medium text-black">({author.fields.nameKanji})</span>
      </div>
    </div>
  );
};
